var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,4v23h31V4H0z M15.5,18.8l1.9-1.6l8.9,6.8H4.7l8.9-6.8L15.5,18.8z M19,15.9l9-7.6v14.4L19,15.9z M25,7 h1.4l-10.9,9.2L4.6,7H17H25z M3,7L3,7L3,7L3,7z M12,15.9l-9,6.9V8.3L12,15.9z M3,24L3,24L3,24L3,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0416754c33e48b5a3f10319f09b0f11c.svg";
export { ForwardRef as ReactComponent };